// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://bpxebrbhhywoayvqwdnh.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImJweGVicmJoaHl3b2F5dnF3ZG5oIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDQ3OTQwNzUsImV4cCI6MjA2MDM3MDA3NX0.aMoMxNwfxI0MuSKxgYri4y1Xrf9tJtTflKAAyZzRRbE";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

// Session token management for custom auth
let _sessionToken: string | null = typeof window !== 'undefined' ? localStorage.getItem('auth_session_token') : null;

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  },
  global: {
    headers: _sessionToken ? { 'x-session-token': _sessionToken } : {},
    fetch: (url: RequestInfo | URL, options: RequestInit = {}) => {
      // Inject current session token into every request
      if (_sessionToken) {
        const headers = new Headers(options.headers);
        headers.set('x-session-token', _sessionToken);
        return fetch(url, { ...options, headers });
      }
      return fetch(url, options);
    },
  },
});

/**
 * Update the x-session-token header on the Supabase client.
 * Call after login (with token) and after logout (with null).
 */
export const updateSupabaseSessionToken = (token: string | null) => {
  _sessionToken = token;
  console.log("[supabase-client] Session token updated:", token ? `${token.slice(0, 12)}...` : 'cleared');
};